
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>

    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}
                <a-tag v-if="record.is_tpl==1" color="blue">标准项目库</a-tag>
                <a-tag v-if="record.can_wyh==1" color="red">省市可见</a-tag>
          </div>
      </span>
      <span slot="status" slot-scope="text,record">


        <a-tag v-if="record.status==1" color="green">显示</a-tag>
        <a-tag v-else>不显示</a-tag>


      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleTreeEdit(record)">可视化编辑</a>
          <a-divider type="vertical" />
          <a @click="handleMemberLimitManage(record)">人数限制</a>
          <a-divider type="vertical" />
          <a @click="handleMusicManage(record)">音乐设置</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>

            </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="名称"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入名称' }]}
            ]"
                         placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="配置规则"
                      hasFeedback
              >
                <a-textarea  v-decorator="[
              'content',
              {rules: [ ]}
            ]"
                          placeholder="请输入配置规则"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="标准项目库"
                      extra="标准项目可以被其他项目配置引用复制"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="is_tpl" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="省市可见"
                      extra="勾选后省市端可见"
                      hasFeedback
              >
                <r-switch  :formData="formData" field="can_wyh" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
            </a-col>
          </a-row>



        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="人数限制"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="memberLimitVisible"
            @ok="memberLimitVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-alert
      message="混合组配置 例如 10-13,14-15,16-17 运动员不能属于单一组别。人数限制配置：如1-10(1位到10位)"
      type="info"
      closable 
    />

          <a-table
                  :columns="memberLimitColumns"
                  :dataSource="memberLimitList"
                  :pagination="false"
                  rowKey="id"
                  :scroll="{ y: 300 }"
                  bordered
          >
           <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="memberLimitQuery.keywords"
                      placeholder="搜索项目"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="memberLimitSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="memberLimitSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            
        <span slot="member_limit" slot-scope="text,record">
          <template >
          <editable-cell :text="record.member_limit" @change="onMemberLimitChange(record.id,'member_limit', $event)"/>
          </template>
        </span>
        <span slot="tb_member_limit" slot-scope="text,record">
          <template >
          <editable-cell :text="record.tb_member_limit" @change="onTbMemberLimitChange(record.id,'tb_member_limit', $event)"/>
          </template>
        </span>
        <span slot="age_limit" slot-scope="text,record">
          <template >
          <editable-cell :text="record.age_limit" @change="onMemberAgeChange(record.id,'age_limit', $event)"/>
          </template>
        </span>
        <span slot="age_mixed_rule" slot-scope="text,record">
          <template >
          <editable-cell :text="record.age_mixed_rule" @change="onMixedChange(record.id,'age_mixed_rule', $event)"/>
          </template>
        </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="音乐设置"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="musicVisible"
            @ok="musicVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
                  :columns="musicColumns"
                  :dataSource="musicList"
                  :pagination="false"
                  rowKey="id"
                  :scroll="{ y: 300 }"
                  bordered
                  :rowSelection="{ selectedItemRowKeys: selectedItemRowKeys, onChange: onSelectItemChange }"
          >
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="musicQuery.keywords"
                      placeholder="搜索项目"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="musicSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="musicSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>

        <span slot="music" slot-scope="text,record">
          <template >

        <a-tag v-if="record.music_url" @click="playUrl=record.music_url" color="green">试听</a-tag>

            <a v-if="!record.isedit" @click="$set(record,'isedit',true)">设置</a>
            <div v-else style="text-align: right">
        <a-select
                showSearch
                allowClear
                v-model="record.music_id"
                optionFilterProp="title"
                placeholder="选择音乐"
        >
          <a-select-option :key="option.id" :title="option.title" v-for="option in musicOptions" :value="option.id">{{option.title}}</a-select-option>

        </a-select>
            <a @click="onMusicDelete(record.id)">清除</a>
          <a-divider type="vertical" />
            <a @click="onMusicSave(record.id,record.music_id)">保存</a>
            </div>
          </template>
        </span>


            <template v-if="selectedItemRows.length>0" slot="footer" slot-scope="currentPageData">
              <a-button  v-if="!musicEditAll.edit" icon="plus" @click="musicEditAll.edit=true" >批量设置</a-button>
              <span v-else style="text-align: right">
                <a-select
                        showSearch
                        allowClear
                        style="width: 300px ; margin-right: 10px;"
                        v-model="musicEditAll.music_id"
                        optionFilterProp="title"
                        placeholder="选择音乐"
                >
                  <a-select-option :key="option.id" :title="option.title" v-for="option in musicOptions" :value="option.id">{{option.title}}</a-select-option>

                </a-select>
                <a @click="onMusicDeletes()">清除</a>
                <a-divider type="vertical" />
                <a @click="onMusicSaves()">保存</a>
              </span>


            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="可视化编辑"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="treeVisible"
            @ok="treeVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2">
          <a-table
                  :columns="treeColumns"
                  :dataSource="treeFormdata.tree"
                  :pagination="false"
                  rowKey="id"
                  :scroll="{ y: 300 }"
                  bordered
          >
        <span slot="name" slot-scope="text,record,index">
          <template >
            <span v-if="record.edit">
              <a-select
                      style="width: 100px; margin-right: 10px  "
                      v-show="treeEditRecord.level>2"
                      v-model="treeEditRecord.subjectaddtype"
                      placeholder="项目类型"
              >
                <a-select-option   value="NEW">新建项目</a-select-option>
                <a-select-option   value="OLD">选择已有项目</a-select-option>
              </a-select>
              <a-select
                      style="width: 100px; margin-right: 10px  "
                      v-show="treeEditRecord.level>2 && treeEditRecord.subjectaddtype=='OLD' "
                      v-model="treeEditRecord.subjecttype"
                      @change="onSubjectTplChange"
                      placeholder="模版类型"
              >
                <a-select-option :key="index" v-for="(tpl,index) in subjectTplList"  :value="index">{{tpl.title}}</a-select-option>
              </a-select>

              <a-input v-if="treeEditRecord.subjectaddtype!='OLD'" v-model="treeEditRecord.name" style="width: 200px; margin-right: 10px  "  allowClear  :placeholder="treeEditRecord.level<=2 ?'请输入组别名称':'请输入项目名称'" />
              <a-tree-select
                      v-else
                       v-model="treeEditRecord.oldsubjectids"
                       :tree-data="subjectTplTreeData"
                      tree-checkable
                      :show-checked-strategy="SHOW_PARENT"
                       style="width: 200px; margin-right: 10px  "
                      placeholder="请选择项目" >
              </a-tree-select>

              <a-select
                      style="width: 100px; margin-right: 10px  "
                      v-if="treeEditRecord.level==1"
                      v-model="treeEditRecord.grouptype"
                      @change="groupTypeOnchange"
                      placeholder="组别类型"
              >
                <a-select-option   value="OPEN">公开</a-select-option>
                <a-select-option   value="CLUB">俱乐部</a-select-option>
              </a-select>
              <a-input  v-if="treeEditRecord.subjectaddtype!='OLD'"  v-model="treeEditRecord.key" style="width: 200px; margin-right: 10px  "   allowClear  placeholder="编号"  />
            </span>
            <span v-else >
              {{record.name}}
              <em v-if="record.level==1">
                <a-tag v-if="record.key.toUpperCase().indexOf('CLUB')>-1" color="blue">俱乐部</a-tag>
                <a-tag v-else color="green">公开</a-tag>
              </em>
            </span>
          </template>
        </span>
        <span slot="action" slot-scope="text,record,index">
          <template >
            <div v-if="record.edit">
              <a v-if="record.level==1" @click="treeNodeGroupSave(record,index)">保存</a>
              <a v-else @click="treeNodeSubjectSave(record,index)">保存</a>
              <a-divider type="vertical" />

          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="treeDelete(record,index)"  okText="确定" cancelText="取消">
              <a  >删除</a>
          </a-popconfirm>
            </div>
            <div v-else>
              <a @click="treeInsertPre(record,index)">插入（前）</a>
              <a-divider type="vertical" />
              <a @click="treeInsertNex(record,index)">插入（后）</a>
              <br/>
              <a @click="treeInsertSub(record,index)">插入（子）</a>
              <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="treeDelete(record,index)"  okText="确定" cancelText="取消">
              <a  >删除</a>
          </a-popconfirm>
              <a-divider type="vertical" />
            </div>
          </template>
        </span>

            <template slot="footer" slot-scope="currentPageData">
              <a-button icon="plus" @click="treeInsertNex({level:1},treeFormdata.tree.length)" >新增组别</a-button>
            </template>
          </a-table>
        </a-form>


      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleTreeCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleTreeOk">保存</a-button>
      </template>
    </a-modal>


    <audio autoplay	 style="position: fixed; bottom: 20px; z-index: 9999999" v-if="playUrl" :src="playUrl" controls="controls"></audio>

  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import RSwitch from '@/components/RSwitch/'
  import moment from 'moment'
  import { TreeSelect } from 'ant-design-vue';

  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  function getNodePath(treeArray, findId){

    // 首先我们先定义个数组，用来保存路径节点id
    let nodePathArray= []
    let idPathArray= []
    let indexPathArray= []

    // (tree为目标树，targetId为目标节点id)
    function getNodeRoute(tree, targetId) {
      for (let index = 0; index < tree.length; index++) {
        if (tree[index].children) {
          let endRecursiveLoop = getNodeRoute(tree[index].children, targetId)
          if (endRecursiveLoop) {
            nodePathArray.push(tree[index])
            idPathArray.push(tree[index].id)
            indexPathArray.push(index)
            return true
          }
        }
        if (tree[index].id === targetId) {
          nodePathArray.push(tree[index])
          idPathArray.push(tree[index].id)
          indexPathArray.push(index)
          return true
        }
      }
    }
    getNodeRoute(treeArray,findId)
    return nodePathArray.reverse();
    // return indexPathArray.reverse();
    // console.log(nodePathArray.reverse().join('->'));
  }
  //
  //将key的前缀加到树的每个节点
  function updateTreeKey(data,pkey){
    const hasChild = data.children && data.children.length > 0
    // 可以根据实际开发需要返回自己想要的key值
    console.log('-new data---',data);
    // data.key = pkey+data.key;
    data.key = pkey+data.key;
    data.children = hasChild ? data.children.map(i => updateTreeKey(i,pkey)) : [];
    return data;
    // return {
    //   id:pkey,
    //   children:hasChild ? data.children.map(i => updateTreeKey(i,pkey)) : []
    // }
  }


  // const newlist = [
  //   {
  //     title: 'Node1',
  //     value: '1',
  //     key: '1',
  //     children:[
  //       {
  //         title: 'Node1.1',
  //         value: '1.1',
  //         key: '1.1',
  //         children:[
  //
  //         ]
  //       },
  //       {
  //         title: 'Node1.2',
  //         value: '1.2',
  //         key: '1.2',
  //         children:[
  //           {
  //             title: 'Node1.2.1',
  //             value: '1.2.1',
  //             key: '1.2.1',
  //             children:[
  //
  //             ]
  //           }
  //         ]
  //       }
  //     ]
  //   },{
  //     title: 'Node2',
  //     value: '2',
  //     key: '2',
  //     children:[
  //
  //     ]
  //   }
  // ].map(item => updateTreeKey(item ,'ppp.'))
  // console.log('newlist',newlist);

  const SHOW_PARENT = TreeSelect.SHOW_PARENT;

  const treeData = [
    {
      title: 'Node1',
      value: '0-0',
      key: '0-0',
      children: [
        {
          title: 'Child Node1',
          value: '0-0-0',
          key: '0-0-0',
        },
      ],
    },
    {
      title: 'Node2',
      value: '0-1',
      key: '0-1',
      children: [
        {
          title: 'Child Node3',
          value: '0-1-0',
          key: '0-1-0',
          disabled: true,
        },
        {
          title: 'Child Node4',
          value: '0-1-1',
          key: '0-1-1',
        },
        {
          title: 'Child Node5',
          value: '0-1-2',
          key: '0-1-2',
        },
      ],
    },
  ];

  import {subjectTplTreeList,saveSubjectTree, subjectTreeList ,subjectTypeList,subjectTypeDetail,editSubjectType,subjectTypeDelete,addSubjectType,getSubjectMemberLimitList,setSubjectMemberLimit,setSubjectTbMemberLimit,setSubjectAgeLimit ,setAgeMixedSubjectLimit,getSubjectMusicList,setSubjectMusic,setSubjectsMusic } from '@/api/sai'
  export default {
    name: 'SubjecttypeList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
              playUrl:'',
              selectedRowKeys:[],
              selectedItemRowKeys:[],
              selectedItemRows:[],
              defaultExpandAllRows:false,
                visible: false,
                saveLoading:false,
                formData:{
                  id:0,
                  status:1,
                  is_tpl:2,
                  can_wyh:2,
                },
                saijiOptions:[],
                labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
                  xs: { span: 24 },
                  sm: { span: 8 },
                },
                wrapperCol: {
                  xs: { span: 24 },
                  sm: { span: 12 },
                },
                form: this.$form.createForm(this),
                form2: this.$form.createForm(this),
                mdl: {},

                // 高级搜索 展开/关闭
                advanced: false,
                // 查询参数
                queryParam: {
                  keywords:'',
                },
                // 表头
                columns: [
                  {
                    title: '#',
                    dataIndex: 'id',
                    width: '50px'
                  },
                  {
                    title: '名称',
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                  },/*
                  {
                    title: '状态',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                  },*/
                  {
                    title: '操作',
                    dataIndex: 'action',
                    fixed: 'right',
                    width: 500,
                    scopedSlots: { customRender: 'action' },
                  }
                ],
                // 加载数据方法 必须为 Promise 对象
                loadData: parameter => {
                            console.log('loadData');
                  console.log(this.queryParam);
                  let that= this;


                  this.queryParam = Object.assign(this.queryParam,parameter);
                  return subjectTypeList(this.queryParam)
                                  .then(res => {
                            console.log('res');
                  return res.data
                })
                },
                //表头
                memberLimitColumns: [
                  {
                    title: '组别/项目',
                    dataIndex: 'name',
                    scopedSlots: {
                      filterDropdown: 'filterDropdown',
                      filterIcon: 'filterIcon',
                      customRender: 'name',
                    }
                  },
                  {
                    title: '人数限制',
                    width: '150px',
                    dataIndex: 'member_limit',
                    scopedSlots: { customRender: 'member_limit' },
                  },
                  {
                    title: '替补人数',
                    width: '150px',
                    dataIndex: 'tb_member_limit',
                    scopedSlots: { customRender: 'tb_member_limit' },
                  },
                  {
                    title: '年龄限制',
                    width: '150px',
                    dataIndex: 'age_limit',
                    scopedSlots: { customRender: 'age_limit' },
                  },
                  {
                    title: '混合规则',
                    width: '150px',
                    dataIndex: 'age_mixed_rule',
                    scopedSlots: { customRender: 'age_mixed_rule' },
                  },
                ],
                memberLimitQuery: {
                  typeid: 0,
                },
              memberLimitVisible:false,
              memberLimitList: [],


              //表头
              treeColumns: [
                {
                  title: '组别/项目',
                  dataIndex: 'name',
                  scopedSlots: { customRender: 'name' },
                },
                {
                  title: '操作',
                  width: '200px',
                  dataIndex: 'action',
                  scopedSlots: { customRender: 'action' },
                },
              ],
        SHOW_PARENT,
        subjectTplTreeData:[],
        subjectTplList:[],
        treeEditRecord:{
          name:'',
          grouptype:'',
          subjectaddtype:'OLD',
          subjecttype:'OLD',
          oldsubjectid:[],
          oldsubjectids:[],
          id:''
        },
        treeFormdata: {
                typeid: 0,
                tree:[]
              },
              treeVisible:false,

              //表头
              musicColumns: [
                {
                  title: '项目',
                  dataIndex: 'name',
                  scopedSlots: {
                    filterDropdown: 'filterDropdown',
                    filterIcon: 'filterIcon',
                    customRender: 'name',
                  }
                },
                {
                  title: '音乐',
                  width: '250px',
                  dataIndex: 'music',
                  scopedSlots: { customRender: 'music' },
                },
              ],
              musicQuery: {
                typeid: 0,
              },
              musicVisible:false,
              musicList: [],
              musicOptions: [],
              musicEditAll:{
                      music_id:'',
                edit:false
              }

      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSubjectTplTreeList();
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      handleTreeCancel(){
        this.treeVisible = false
      },
      addHandle(){
        this.formData ={
          id:0,
          content:'',
          is_tpl:2,
          can_wyh:2,
        }
        this.form.resetFields();
        this.visible = true
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        self.saveLoading = true;
        subjectTypeDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
          self.form.setFieldsValue({ ...res.data })
          self.formData.id = record.id;
          console.log('handleEdit')
          self.formData = { ...res.data };
          self.saveLoading = false;
        },200)
      })
        // console.log(this.mdl)
      },
      handleTreeEdit(record){
        let self = this
        this.treeVisible = true
        self.saveLoading = true;
        subjectTreeList({ typeid: record.id }).then(res => {
          setTimeout(() =>{
          self.form2.setFieldsValue({ ...res.data })
          self.treeFormdata = { ...res.data };
          self.saveLoading = false;
        },200)
      })
        // console.log(this.mdl)
      },
      getSubjectTplTreeList(){
        let self = this
        subjectTplTreeList().then(res => {
          self.subjectTplList = res.data;
      })
        // console.log(this.mdl)
      },


      // 删
      deleteHandle(record) {
        let self = this
        subjectTypeDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id>0){
              editSubjectType({
                id:self.formData.id,
                is_tpl:self.formData.is_tpl,
                can_wyh:self.formData.can_wyh,
                name:values.name,
                content:values.content,
              }).then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addSubjectType({
                name:values.name,
                is_tpl:self.formData.is_tpl,
                can_wyh:self.formData.can_wyh,
                content:values.content,
              }).then(res => {
                self.$message.success('保存成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }
          }
        })
      },

      handleMemberLimitManage(record) {
        let self = this
        self.fetchMemberLimitList()
        self.memberLimitQuery.typeid = record.id;
        this.memberLimitVisible = true
      },


      fetchMemberLimitList() {
        let self = this
        self.saveLoading = true;
        getSubjectMemberLimitList(self.memberLimitQuery).then(res => {
          self.memberLimitList = res.data
          self.saveLoading = false;
        })
      },

      onMemberLimitChange(key, dataIndex, value) {
        let self = this;
        console.log(dataIndex);
        setSubjectMemberLimit({
          typeid: self.memberLimitQuery.typeid,
          subject: key,
          member_limit:value
        }).then(res => {
          self.fetchMemberLimitList()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      onTbMemberLimitChange(key, dataIndex, value) {
        let self = this;
        console.log(dataIndex);
        setSubjectTbMemberLimit({
          typeid: self.memberLimitQuery.typeid,
          subject: key,
          member_limit:value
        }).then(res => {
          self.fetchMemberLimitList()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      onMemberAgeChange(key, dataIndex, value) {
        let self = this;
        console.log(dataIndex);
        setSubjectAgeLimit({
          typeid: self.memberLimitQuery.typeid,
          subject: key,
          age_limit:value
        }).then(res => {
          self.fetchMemberLimitList()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      onMixedChange(key, dataIndex, value) {
        let self = this;
        console.log(dataIndex);
        setAgeMixedSubjectLimit({
          typeid: self.memberLimitQuery.typeid,
          subject: key,
          age_mixed_rule:value
        }).then(res => {
          self.fetchMemberLimitList()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      handleMusicManage(record) {
        let self = this
        self.fetchMusicList()
        self.musicQuery.typeid = record.id;
        this.musicVisible = true
      },


      fetchMusicList() {
        let self = this
        self.saveLoading = true;
        getSubjectMusicList(self.musicQuery).then(res => {
          self.musicList = res.data.list
          self.musicOptions = res.data.options;
          self.saveLoading = false;
        })
      },

      onMusicSave(key, value) {
        let self = this;
        if(!value){
          self.$message.error('请选择音乐')
        }
        setSubjectMusic({
          typeid: self.musicQuery.typeid,
          subject: key,
          music_id:value
        }).then(res => {
          self.fetchMusicList()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      onMusicDelete(key) {
        let self = this;
        setSubjectMusic({
          typeid: self.musicQuery.typeid,
          subject: key,
          music_id:0
        }).then(res => {
          self.fetchMusicList()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      onMusicSaves() {
        let self = this;
        setSubjectsMusic({
          typeid: self.musicQuery.typeid,
          subjects: self.selectedItemRows.map(item => {
            return item.id;
          }),
          music_id:self.musicEditAll.music_id
        }).then(res => {
          self.fetchMusicList()
          self.selectedItemRows=[];
          self.selectedItemRowKeys=[];
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      onMusicDeletes() {
        let self = this;
        setSubjectsMusic({
          typeid: self.musicQuery.typeid,
          subjects: self.selectedItemRows.map(item => {
            return item.id;
          }),
          music_id:0
        }).then(res => {
          self.fetchMusicList();
          self.selectedItemRows=[];
          self.selectedItemRowKeys=[];
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      groupTypeOnchange(value){
        console.log(value);
        let that = this;
        that.treeEditRecord.key = value+'-'+that.treeFormdata.id+'-'+(that.treeEditRecord.index+1);
      },
      onSubjectTplChange(value){
        console.log(value);
        this.subjectTplTreeData = this.subjectTplList[value].tree;

      },
      treeInsertPre(record,index){
        let that = this;
        // console.log(getNodePath(that.treeFormdata.tree,record.id),record,index)
        if(that.treeEditRecord.edit==true){
          this.$message.error('请先保存正在编辑的组别/项目');
          return false;
        }

        that.treeEditRecord = {
          children: [],
          index: index,
          id: '',
          oldsubjectids: [],
          oldsubjectid: '',
          subjectaddtype: '',
          subjecttype: '',
          key: '',
          level: record.level,
          name: '',
          edit:true,
          p_key: '',
        }
        if(record.level==1){
          //顶级
          that.treeEditRecord.grouptype = 'OPEN';
          that.treeEditRecord.p_key = '';
          that.treeEditRecord.key = 'OPEN'+'-'+that.treeFormdata.id+'-'+(index+1);
          that.treeFormdata.tree.splice(index, 0,that.treeEditRecord );
        }else{
          //子级
          that.treeEditRecord.subjectaddtype = 'NEW';
          let nodes = getNodePath(that.treeFormdata.tree,record.id);
          nodes.pop();
          let parentNode = nodes.pop();
          that.treeEditRecord.p_key = parentNode.key;
          that.treeEditRecord.key = parentNode.key+'.'+(index+1);
          parentNode.children.splice(index, 0, that.treeEditRecord);
          console.log(parentNode);
        }
      },
      treeInsertNex(record,index){
        index = index+1; //插入后面需要index+1
        let that = this;
        console.log('treeInsertNex',record,index)
        // console.log(getNodePath(that.treeFormdata.tree,record.id),record,index)
        if(that.treeEditRecord.edit==true){
          this.$message.error('请先保存正在编辑的组别/项目');
          return false;
        }
        that.treeEditRecord = {
          children: [],
          index: index,
          id: '',
          oldsubjectids: [],
          oldsubjectid: '',
          subjectaddtype: '',
          subjecttype: '',
          key: '',
          level: record.level,
          name: '',
          edit:true,
          p_key: '',
        }
        if(record.level==1){
          //顶级
          that.treeEditRecord.grouptype = 'OPEN';
          that.treeEditRecord.p_key = '';
          that.treeEditRecord.key = 'OPEN'+'-'+that.treeFormdata.id+'-'+(index+1);
          that.treeFormdata.tree.splice(index, 0,that.treeEditRecord );
        }else{
          //子级
          that.treeEditRecord.subjectaddtype = 'NEW';
          let nodes = getNodePath(that.treeFormdata.tree,record.id);
          nodes.pop();
          let parentNode = nodes.pop();
          that.treeEditRecord.p_key = parentNode.key;
          that.treeEditRecord.key = parentNode.key+'.'+(index+1);
          parentNode.children.splice(index, 0, that.treeEditRecord);
          console.log(parentNode);
        }

      },
      treeInsertSub(record,index){
        index = 0 ;//插入第一个子集
        let that = this;
        console.log('parentNode',record);
        if(typeof  record.children == 'undefined'){
          // record.children = [];
          that.$set(record,'children',[]);
        }
        // console.log(getNodePath(that.treeFormdata.tree,record.id),record,index)
        if(that.treeEditRecord.edit==true){
          this.$message.error('请先保存正在编辑的组别/项目');
          return false;
        }



        that.treeEditRecord = {
          children: [],
          index: index,
          id: '',
          oldsubjectids: [],
          oldsubjectid: '',
          subjectaddtype: '',
          subjecttype: '',
          key: '',
          level: record.level+1,
          name: '',
          edit:true,
          p_key: '',
        }
        //肯定是子级
        that.treeEditRecord.subjectaddtype = 'NEW';
        let nodes = getNodePath(that.treeFormdata.tree,record.id);
        let parentNode = nodes.pop(); //当前节点是父级
        that.treeEditRecord.p_key = parentNode.key;
        that.treeEditRecord.key = parentNode.key+'.'+(index+1);
        console.log('parentNode',parentNode);
        record.children.splice(index, 0, that.treeEditRecord);
        console.log(parentNode);
      },
      treeNodeGroupSave(record,index){
        console.log(record);
        let that = this;
        if(!record.name){
          this.$message.error('请输入名称');
          return false;
        }
        if(!record.key){
          this.$message.error('编码不能为空');
          return false;
        }
        if(record.level==1){
          let idExistList = that.treeFormdata.tree.filter(item =>{
            return (item.key == record.key  && item.edit == false)
          })
          if(idExistList.length >0 ){
            this.$message.error('编码（'+record.key+'）与['+idExistList[0].name+']重复，请修改');
            return ;
          }

          let nameExistList = that.treeFormdata.tree.filter(item =>{
            return (item.name == record.name  && item.edit == false)
          })
          if(nameExistList.length >0 ){
            this.$message.error('名称（'+record.name+'）重复，请修改');
            return ;
          }
        } else{
          let nodes = getNodePath(that.treeFormdata.tree,record.id);
          nodes.pop();
          let parentNode = nodes.pop();
          let idExistList = parentNode.children.filter(item =>{
            return (item.key == record.key  && item.edit == false)
          })
          if(idExistList.length >0 ){
            this.$message.error('编码（'+record.key+'）与['+idExistList[0].name+']重复，请修改');
            return ;
          }

          let nameExistList = parentNode.children.filter(item =>{
            return (item.name == record.name  && item.edit == false)
          })
          if(nameExistList.length >0 ){
            this.$message.error('名称（'+record.name+'）重复，请修改');
            return ;
          }
        }


        record.edit=false;
        record.id=record.key;
        this.treeEditRecord.edit=false;
      },
      treeNodeSubjectSave(record,index){
        console.log(record);
        let that = this;

        if(record.subjectaddtype=='NEW'){

          if(!record.name){
            this.$message.error('请输入名称');
            return false;
          }
          if(!record.key){
            this.$message.error('编码不能为空');
            return false;
          }
          if(record.level==1){
            let idExistList = that.treeFormdata.tree.filter(item =>{
              return (item.key == record.key  && item.edit == false)
            })
            if(idExistList.length >0 ){
              this.$message.error('编码（'+record.key+'）与['+idExistList[0].name+']重复，请修改');
              return ;
            }

            let nameExistList = that.treeFormdata.tree.filter(item =>{
              return (item.name == record.name  && item.edit == false)
            })
            if(nameExistList.length >0 ){
              this.$message.error('名称（'+record.name+'）重复，请修改');
              return ;
            }
          } else{
            let nodes = getNodePath(that.treeFormdata.tree,record.id);
            nodes.pop();
            let parentNode = nodes.pop();
            let idExistList = parentNode.children.filter(item =>{
              return (item.key == record.key  && item.edit == false)
            })
            if(idExistList.length >0 ){
              this.$message.error('编码（'+record.key+'）与['+idExistList[0].name+']重复，请修改');
              return ;
            }

            let nameExistList = parentNode.children.filter(item =>{
              return (item.name == record.name  && item.edit == false)
            })
            if(nameExistList.length >0 ){
              this.$message.error('名称（'+record.name+'）重复，请修改');
              return ;
            }
          }

          record.edit=false;
          record.id=record.key;
          this.treeEditRecord.edit=false;

        }else{
          //从模版新建
          if(record.oldsubjectids.length==0){
            this.$message.error('请至少选择一个项目');
          }

          // that.treeEditRecord.p_key = parentNode.key;
          // that.treeEditRecord.key = parentNode.key+'.'+(index+1);
          // parentNode.children.splice(index, 0, that.treeEditRecord);

          let nodes = getNodePath(that.treeFormdata.tree,record.id);
          nodes.pop();
          let parentNode = nodes.pop();
          let oldsubjectids = [...record.oldsubjectids];

          parentNode.children.splice(index, 1);
          oldsubjectids.reverse().map((item,itemindex) =>{

            let thisnodes = getNodePath(that.subjectTplTreeData,item).pop();
            //更新key ,需要更新level？
            console.log('new old thisnodes',thisnodes);
            thisnodes =  updateTreeKey(JSON.parse(JSON.stringify(thisnodes)) ,parentNode.key+'.');
            console.log('new thisnodes',thisnodes);
            thisnodes.edit = false
            // if(itemindex == 0){
            //   record=thisnodes;
            //   record.edit=false;
            // }else{
              // parentNode.children.splice(index, 1);
              parentNode.children.splice(index, 0, thisnodes);
            // }
          });
          this.treeEditRecord.edit=false;
          console.log(record.oldsubjectids);
          console.log(that.treeFormdata.tree);

        }


      },
      treeDelete(record,index){
        let that = this;
        record.edit=false;
        that.treeEditRecord.edit=false;
        if(record.level==1){
          //顶级
          that.treeFormdata.tree.splice(index, 1);
        }else{
          //子级
          let nodes = getNodePath(that.treeFormdata.tree,record.id);
          nodes.pop();
          let parentNode = nodes.pop();
          parentNode.children.splice(index, 1);
        }

      },


      // 增改 处理
      handleTreeOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
            saveSubjectTree({
              id:self.treeFormdata.id,
              tree:JSON.stringify(self.treeFormdata.tree),
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.treeVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      onSelectItemChange (selectedItemRowKeys, selectedItemRows) {
        this.selectedItemRowKeys = selectedItemRowKeys
        this.selectedItemRows = selectedItemRows
        console.log(selectedItemRows)
      },


      musicSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchMusicList();
      },
      musicSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.musicQuery.keywords = undefined;
        self.fetchMusicList();
      },

      memberLimitSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchMemberLimitList();
      },
      memberLimitSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.memberlimitQuery.keywords = undefined;
        self.fetchMemberLimitList();
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>

<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
